<template>
  <div class="c-map">
    <div id="c-map" />

    <div class="c-map__actions">
      <map-tools
        :map="mapgl"
        :is-traffic-counts="true"
        @change-prop="changeProp"
        :map-bearing="mapBearing"
        :is3d="is3d"
      />
    </div>

    <map-popup :settings="popupSettings" />

    <div v-if="overlay" class="c-map__overlay" />

    <div v-if="mapLoading" class="c-map__loader">
      <i class="el-icon-loading" />
      Загрузка данных...
    </div>
  </div>
</template>

<script>
import MapTools from "@/components/map/components/map-tools/map-tools";
import MapPopup from "@/components/map/components/map-popup/map-popup";
import { initMap } from "./core";

export default {
  components: {
    MapTools,
    MapPopup
  },
  data() {
    return {
      mapgl: null,
      mapBearing: null,
      is3d: false,
      isLegendActive: true,
      controllers: {},
      popupSettings: {
        display: "none",
        top: 0,
        left: 0,
        values: []
      },
      editorState: this.$store.state.calculations.editorState
    };
  },
  computed: {
    mapLoading() {
      return this.$store.state.calculations.loadingLayers.length > 0;
    },
    overlay() {
      return this.$store.state.calculations.overlay;
    }
  },
  watch: {
    // "$store.state.theme": function(val, prev) {
    //   this.mapgl.setLayoutProperty(prev, "visibility", "none");
    //   this.mapgl.setLayoutProperty(val, "visibility", "visible");
    // },
    $route: {
      handler: function(to, from) {
        const { model } = this.controllers;
        const { name } = this.$route;

        if (name === from.name) return;

        if (from.name === "c-editor") {
          this.controllers.editor.toggleEditorOff();
        }

        switch (name) {
          case "c-models":
            model.toggleModelOff();
            return;
          case "c-scenarios":
            if (from.name === "c-models") {
              model.toggleModelOn();
            } else {
              this.controllers.layers.setBaseLayers();

              this.$store.commit("SET_CALC_FIELD", {
                field: "settingsId",
                value: null
              });
            }

            return;
          case "c-editor":
            this.controllers.editor.toggleEditorOn();
            return;
          case "c-scenario":
            this.controllers.layers.setBaseLayers();
            return;
        }
      }
    },
    "$store.state.calculations.currentTime": function() {
      this.controllers.layers.updateLayers();

      console.log("current time watcher");
    },
    "$store.state.calculations.settingsId": function() {
      this.$nextTick(() => this.mapgl.resize({ noRequest: true }));
    }
  },
  methods: {
    saveMapParams() {
      const zoom = this.mapgl.getZoom();
      const center = this.mapgl.getCenter();

      localStorage.setItem("cMapCenter", JSON.stringify(center));
      localStorage.setItem("cMapZoom", JSON.stringify(zoom));
    },
    changeProp({ field, value }) {
      this[field] = value;
    },
    toggleLegend() {
      this.isLegendActive = !this.isLegendActive;
    },
    getObjectsLimit() {
      return 10000;
    }
  },
  mounted() {
    initMap(this);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.saveMapParams);
    this.saveMapParams();
  }
};
</script>

<style lang="scss">
.c-map {
  height: 100%;
  width: 100%;
  position: relative;

  &__actions {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 100;
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }

  &__loader {
    position: absolute;
    top: 10px;
    left: calc(50%);
    transform: translateX(-50%);
    font-size: 12px;
    line-height: 18px;
    padding: 10px 20px;
    border-radius: var(--border-radius);
    border: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;
    background-color: var(--bg_panel_primary) !important;
    display: flex;
    align-items: center;
    color: var(--accent_primary) !important;

    i {
      font-size: 18px;
      line-height: 18px;
      margin-right: 5px;
    }
  }

  #c-map {
    width: 100%;
    height: 100%;
  }

  .mapboxgl-canvas {
    &:focus {
      outline: none;
    }
  }
  .mapboxgl-ctrl-top-right {
    display: none;
  }
}
</style>
